module.exports = __webpack_public_path__ + "static/media/community-concessions-banner.7c6ce15d.jpg";